import { setUnpublishPending, unpublishPublishedCalendar } from '../actions/calendarPublishing';
import { createCalendarPublishingPermission } from '../utils/CalendarPublishingUtils';
import { orchestrator } from 'satcheljs';
import { isConsumer } from 'owa-session-store';

export default orchestrator(unpublishPublishedCalendar, async msg => {
    const { folderId, detailLevel } = msg;
    setUnpublishPending(folderId, detailLevel, true);
    if (isConsumer()) {
        // consumer has an explicit publish=false permission, but enterprise just sets to disabled
        await createCalendarPublishingPermission(folderId, detailLevel, false /*publishCalendar*/);
    } else {
        await createCalendarPublishingPermission(folderId, 'Disabled');
    }
    setUnpublishPending(folderId, detailLevel, true);
});
